import jQuery from 'jquery';

export default jQuery(function() {

    // Scroll to active assignment on page load
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('active')) {
        const activeID = urlParams.get('active');
        const $activeAssignment = jQuery(`#js-assignment-${activeID}`);

        $('html, body').animate({
            scrollTop: $activeAssignment.offset().top - $activeAssignment.outerHeight() / 2
        }, 'fast');
    }

    jQuery('.js-assignment__trigger').click(function() {
        const trigger = jQuery(this);

        trigger.closest('.js-assignment').toggleClass('is-active');
        trigger.closest('.js-assignment').find('.js-assignment__details').slideToggle();
    })
});
